<script>
  import Message from '@commercebear/components/Message';

  export let testid = undefined;
  export let message = undefined;
  export let error = undefined;
  export let success = undefined;
  export let method = undefined;
  export let action = undefined;
</script>

<form class="brand-form" {method} {action} data-cy={testid}>
  <slot />

  {#if error}
    <div class='message'>
      <Message appearance='error' testid='form-error' copy={false}>
        {error}
      </Message>
    </div>
  {/if}

  {#if success}
    <div class='message'>
      <Message appearance='success' testid='form-success' copy={false}>
        {success}
      </Message>
    </div>
  {/if}

  {#if message}
    <div class='message'>
      <Message testid='form-message' copy={false}>
        {message}
      </Message>
    </div>
  {/if}

  {#if $$slots.action}
    <div class='actions'>
      <slot name='action' />
    </div>
  {/if}
</form>


<style>
  .brand-form {
    flex-grow: 1;
  }
  
  .message {
    margin-top: var(--spacing--l);
  }

  .actions {
    margin-top: var(--spacing--xl);
  }
</style>
